import { computed, observable } from 'mobx';
import ConfigRepository from '../../repositories/ConfigRepository';
import TransactionRepository from '../../repositories/TransactionRepository';
import Transaction from '../../domain/entities/Transaction/Transaction';
import Config, { IConvenienceStoreProvider, CONVENIENCE_STORE } from '../../domain/entities/Config';
import { DeliveryOptions } from '../../constants/Constants';
import ConvenienceStore from '../../domain/entities/ConvenienceStore/ConvenienceStore';
import RedirectUserUseCase from '../../use-cases/RedirectUserUseCase';

interface IConvenienceStoreViewControllerData {
  convenienceStore: ConvenienceStore;
}

export interface IConvenienceStoreViewControllerConfig {
  configRepository: ConfigRepository;
  transactionRepository: TransactionRepository;
}

export default class ConvenienceStoreViewController {
  private config: Config;

  @observable transaction: Transaction;

  private configRepository: ConfigRepository;

  private transactionRepository: TransactionRepository;

  private selectedProvider: IConvenienceStoreProvider;

  constructor(config: IConvenienceStoreViewControllerConfig) {
    const { configRepository, transactionRepository } = config;
    this.configRepository = configRepository;
    this.transactionRepository = transactionRepository;
  }

  async loaded(): Promise<void> {
    this.config = await this.configRepository.getConfig();
    this.transaction = await this.transactionRepository.getTransaction();

    if (this.storeProviders?.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      this.selectedProvider = this.storeProviders[0];
    }
  }

  @computed
  private get storeProviders(): IConvenienceStoreProvider[] {
    return this.transaction?.deliveryOptions
      .find(deliveryOption => deliveryOption.name === DeliveryOptions.CONVENIENCE_STORE_PICK_UP)
      ?.config?.convenienceStoreProviders;
  }

  @computed
  public get data(): IConvenienceStoreViewControllerData {
    return {
      convenienceStore: this.transaction?.convenienceStore,
    };
  }

  public onSelectStore = (): void => {
    if (this.selectedProvider) {
      const { name, url } = this.selectedProvider;
      const redirectUrl = url.replace(/::base_url::/gi, this.config.baseUrl);
      switch (name) {
        case CONVENIENCE_STORE.SAGAWA:
          new RedirectUserUseCase(redirectUrl).execute();
          break;

        // more convenience store handler can be added here such as 'family-mart', '7-11'
        default:
      }
    }
  };
}
